import { render, staticRenderFns } from "./BillingWork.vue?vue&type=template&id=335bc57d&scoped=true&"
import script from "./BillingWork.vue?vue&type=script&lang=js&"
export * from "./BillingWork.vue?vue&type=script&lang=js&"
import style0 from "./BillingWork.vue?vue&type=style&index=0&id=335bc57d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335bc57d",
  null
  
)

export default component.exports